
import { AlertTriangle, X } from 'lucide-react';

interface UnlinkModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    assetName: string;
    isSubmitting: boolean;
}

export default function UnlinkModal({ open, onClose, onConfirm, assetName, isSubmitting }: UnlinkModalProps) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[9999] flex items-center justify-center p-4">
            <div className="bg-gray-900 border border-gray-700 rounded-xl shadow-2xl max-w-sm w-full overflow-hidden transform transition-all animate-fadeIn">
                <div className="p-5">
                    <div className="flex justify-between items-start mb-4">
                        <div className="p-2 bg-red-500/20 rounded-full">
                            <AlertTriangle className="w-6 h-6 text-red-500" />
                        </div>
                        <button onClick={onClose} disabled={isSubmitting} className="text-gray-400 hover:text-white transition-colors">
                            <X className="w-5 h-5" />
                        </button>
                    </div>

                    <h3 className="text-lg font-bold text-white mb-2">Unlink Asset?</h3>
                    <p className="text-gray-400 text-sm mb-6">
                        This will unlink <span className="text-white font-medium">"{assetName}"</span> from the switch and remove it from the canvas. This action cannot be undone.
                    </p>

                    <div className="flex gap-3">
                        <button
                            onClick={onClose}
                            disabled={isSubmitting}
                            className="flex-1 px-4 py-2 bg-gray-800 hover:bg-gray-700 text-gray-300 rounded-lg text-sm font-medium transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={onConfirm}
                            disabled={isSubmitting}
                            className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
                        >
                            {isSubmitting ? (
                                <>
                                    <div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                                    Unlinking...
                                </>
                            ) : (
                                'Unlink & Remove'
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
